// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__3niUD","changelog-history-link":"Header_changelog-history-link__3PuhE"};